import toastr from 'toastr';
import _findIndex from 'lodash/findIndex';
import _pick from 'lodash/pick';

export default class serviceutils {
    static callService(context, serviceFunc, serverCheckFunc, processDataFunc, errorFunc) {
        serviceFunc(context)
            .then((response) => {
                return serverCheckFunc(context, response).json();
            })
            .then((data) => {
                if (data.success) {
                    return processDataFunc(context, data);
                } else {
                    throw new Error(data.errors);
                }
            })
            // This is poor, reduce toastr use
            .catch((errors) => {
                if (errorFunc) {
                    return errorFunc(context, errors);
                } else {
                    errors.map((item) => toastr.error(item));
                }
            });
    }

    static checkForFetchServerError(response, error) {
        if (response.ok) return response.json();
        else throw new Error(`${error} (${response.status} ${response.statusText})`);
    }

    static processErrors(errors) {
        if (Array.isArray(errors)) {
            errors.map((item) => toastr.error(item));
        } else {
            toastr.error(errors);
        }
    }

    static processHeaderInfo(newInfo, headerInfo) {
        let hiDraft = [ ...headerInfo ];
        newInfo.forEach((el) => {
            let index = _findIndex(hiDraft, _pick(el, 'name'));
            if (index > -1) hiDraft.splice(index, 1, el);
            else hiDraft.push(el);
        });
        return hiDraft;
    }
}
